import Stomp, { Client } from 'webstomp-client';
import SockJS from 'sockjs-client';
import store from 'cache/store';
import { cacheStompRH } from 'features/socketSlice';
interface RONGHO {
    stompClient: Client | null;
    connect: () => void;
    disconnect: () => void;
    sendMessage: (topic: string, payload: any) => void;
}

const rhSocket: RONGHO = {
    stompClient: null,

    connect: () => {
        const urlRH = process.env.REACT_APP_RH_MINIGAME;
        const { tokenRH } = store.getState().auth;
        const url = `${urlRH}/gamemini/ws/rongho?access_token=${tokenRH}`;
        const socket = new SockJS(url);
        const stompClient = Stomp.over(socket);
        rhSocket.stompClient = stompClient;
        stompClient.debug = () => {};
        const header = {
            Authorization: tokenRH || '',
        };
        stompClient.connect(header, () => {
            store.dispatch(cacheStompRH(stompClient));
        });
    },
    disconnect: () => {
        if (rhSocket.stompClient) {
            rhSocket.stompClient.disconnect();
        }
    },
    sendMessage: (topic: string, payload: any) => {
        if (rhSocket.stompClient && rhSocket.stompClient.connected) {
            const { apiToken } = store.getState().auth;
            const header = {
                Authorization: apiToken || '',
            };
            rhSocket.stompClient.send(
                topic, // destination
                JSON.stringify(payload), // body
                header // header
            );
        }
    },
};
export default rhSocket;
